import { RefreshIdentifier } from '../enums/refresh-identifier.enum';
import { environment } from 'src/environments/environment';

export class NotificationRequest {
    constructor() {
        this.lastUpdateTime = new Date().toISOString();
        this.refreshInterval = environment.refresh_view_delay / 1000;
    }
    notificationType: RefreshIdentifier;
    data: Object;
    lastUpdateTime: string;
    refreshInterval: number;
}
